import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import NavbarCoin from "../components/NavbarCoin";
import {
  createTheme,
  LinearProgress,
  makeStyles,
  Typography,
  Button,
} from "@material-ui/core";
import axios from "axios";
import { useParams } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import CoinInfo from "../components/CoinInfo";
import { SingleCoin } from "../config/api";
import { numberWithCommas } from "../components/CryptoStats/CoinTable";
import { CryptoState } from "../CryptoContext";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../Firebase";
import SidebarCoin from "../components/SidebarCoin/index";

const CoinPage = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const { id } = useParams();
  const [coin, setCoin] = useState();

  const { currency, symbol, user, setAlert, watchlist } = CryptoState();

  const fetchCoin = async () => {
    const { data } = await axios.get(SingleCoin(id));

    setCoin(data);
  };

  useEffect(() => {
    fetchCoin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        alignItems: "center",
      },
    },
    sidebar: {
      width: "30%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: 25,
      borderRight: "2px solid grey",
    },
    heading: {
      fontWeight: "bold",
      marginBottom: 20,
      fontFamily: "Montserrat",
    },
    description: {
      width: "100%",
      fontFamily: "Montserrat",
      padding: 25,
      paddingBottom: 15,
      paddingTop: 0,
      textAlign: "justify",
    },
    marketData: {
      alignSelf: "start",
      padding: 25,
      paddingTop: 10,
      width: "100%",
      [theme.breakpoints.down("md")]: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
      [theme.breakpoints.down("xs")]: {
        alignItems: "start",
      },
    },
  }));

  const inWatchlist = watchlist.includes(coin?.id);

  const addToWatchlist = async () => {
    const coinRef = doc(db, "watchlist", user.uid);
    try {
      await setDoc(
        coinRef,
        { coins: watchlist ? [...watchlist, coin?.id] : [coin?.id] },
        { merge: true }
      );

      setAlert({
        open: true,
        message: `${coin.name} Added to the Watchlist !`,
        type: "success",
      });
    } catch (error) {
      setAlert({
        open: true,
        message: error.message,
        type: "error",
      });
    }
  };

  const removeFromWatchlist = async () => {
    const coinRef = doc(db, "watchlist", user.uid);
    try {
      await setDoc(
        coinRef,
        { coins: watchlist.filter((wish) => wish !== coin?.id) },
        { merge: true }
      );

      setAlert({
        open: true,
        message: `${coin.name} Removed from the Watchlist !`,
        type: "success",
      });
    } catch (error) {
      setAlert({
        open: true,
        message: error.message,
        type: "error",
      });
    }
  };

  const darkTheme = createTheme({
    palette: {
      primary: {
        main: "#fff",
      },
      type: "dark",
    },
  });

  const toggleMessage = () => {
    setAlert({
      open: true,
      type: "success",
      message: "Click on above login button !",
    });
  };

  const classes = useStyles();

  if (!coin) return <LinearProgress style={{ backgroundColor: "#01bf71" }} />;

  return (
    <>
      <SidebarCoin isOpen={isOpen} toggle={toggle} />
      <NavbarCoin toggle={toggle} />

      <div
        className={darkTheme}
        style={{
          backgroundColor: "black",
          color: "white",
        }}
      >
        <div className={classes.container}>
          <div className={classes.sidebar}>
            <img
              // eslint-disable-next-line
              src={coin?.image.large}
              alt="coin"
              height="200"
              style={{ marginBottom: 20, marginTop: 60 }}
            />
            <Typography variant="h3" className={classes.heading}>
              {coin?.name}
            </Typography>
            <Typography variant="subtitle1" className={classes.description}>
              {ReactHtmlParser(coin?.description.en.split(". ")[0])}
            </Typography>
            <div className={classes.marketData}>
              <span style={{ display: "flex" }}>
                <Typography variant="h5" className={classes.heading}>
                  Rank:
                </Typography>
                &nbsp; &nbsp;
                <Typography
                  variant="h5"
                  style={{
                    fontFamily: "Montserrat",
                  }}
                >
                  {numberWithCommas(coin?.market_cap_rank)}
                </Typography>
              </span>
              <span style={{ display: "flex" }}>
                <Typography variant="h5" className={classes.heading}>
                  Current Price:
                </Typography>
                &nbsp; &nbsp;
                <Typography
                  variant="h5"
                  style={{
                    fontFamily: "Montserrat",
                  }}
                >
                  {symbol}
                  {numberWithCommas(
                    coin?.market_data.current_price[currency.toLowerCase()]
                  )}
                </Typography>
              </span>
              <span style={{ display: "flex" }}>
                <Typography variant="h5" className={classes.heading}>
                  Market Cap:
                </Typography>
                &nbsp; &nbsp;
                <Typography
                  variant="h5"
                  style={{
                    fontFamily: "Montserrat",
                  }}
                >
                  {symbol}
                  {numberWithCommas(
                    coin?.market_data.market_cap[currency.toLowerCase()]
                      .toString()
                      .slice(0, -6)
                  )}
                  M
                </Typography>
              </span>
              {user && (
                <Button
                  variant="outlined"
                  style={{
                    width: "100%",
                    height: 40,
                    backgroundColor: inWatchlist ? "#ff0000" : "#01bf71",
                  }}
                  onClick={inWatchlist ? removeFromWatchlist : addToWatchlist}
                >
                  {inWatchlist ? "Remove from Watchlist" : "Add to Watchlist"}
                </Button>
              )}

              {!user && (
                <Button
                  variant="outlined"
                  style={{
                    width: "100%",
                    height: 40,
                    backgroundColor: "#01bf71",
                  }}
                  onClick={toggleMessage}
                >
                  {"Watchlist this coin"}
                </Button>
              )}
            </div>
          </div>
          <CoinInfo coin={coin} />
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CoinPage;
